document.addEventListener("DOMContentLoaded", function() {

    // swiper detail projektu - náhledy vedle fotografie
    //=====================================================
    (function () {
        let galleryTop, galleryThumbs;

        let swiperTop = document.querySelector('.JS-photo-slider-project-primary');
        if(typeof(swiperTop) != 'undefined' && swiperTop != null){
            galleryTop = new Swiper(swiperTop, {
                spaceBetween: 10,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                loop: true,
                loopedSlides: 4
            });
        }

        let swiperBottom = document.querySelector('.JS-photo-slider-project-secondary');
        if(typeof(swiperBottom) != 'undefined' && swiperBottom != null){
            galleryThumbs = new Swiper(swiperBottom, {
                spaceBetween: 10,
                slidesPerView: 4,
                slideToClickedSlide: true,
                loop: true,
                loopedSlides: 4,
                direction: "vertical"
            });

            galleryTop.controller.control = galleryThumbs;
            galleryThumbs.controller.control = galleryTop;
        }
    }());
});